import type { DatasourceMap } from '../datasource.types'

// Splunk datasource mappings.
//
// Splunk's prelude is log-source-scoped: the customer's `logCategory`
// (endpoint:sysmon, endpoint:wineventlog, etc.) determines which EventCode
// values can appear. The Windows Security event 4688 is meaningless in a
// Sysmon index and vice-versa, so merging them produces queries that match
// zero events in one source and over-match in the other.
//
// Event codes therefore live in `splunkEventCodeByLogCategory` (below) and
// are keyed by (logCategory, huntCategory). `emitSplunkDatasource` reads
// that table using the logCategory attached to the AST by
// `renderSiemGrouped`.
//
// `splunkMap` remains an empty scaffold so the shared `resolveDatasource`
// resolves a NormalizedDataSource object (categories + logCategory) without
// emitting stale event-code data. Splunk has no routing metadata
// (repo/sourcetype are handled by Matchboi's FieldMapping, not the prelude).
export const splunkMap: DatasourceMap = {
  Splunk: {
    any: {},
  },
}

/**
 * Splunk EventCode prelude table, scoped by (logCategory, huntCategory).
 *
 * Only includes entries where a real Windows Security / Sysmon event id
 * exists for the pair. Missing entries → no prelude emitted (body-only
 * query), which is the correct behavior for log sources that don't carry
 * that hunt category (e.g. domain/url IOCs on Sysmon).
 */
export const splunkEventCodeByLogCategory: Record<
  string,
  Record<string, string[]>
> = {
  'endpoint:sysmon': {
    process_creation: ['1'],
    file_event: ['11'],
    registry_event: ['13'],
    image_load: ['7'],
    pipe_created: ['17', '18'],
    dns: ['22'],
    network_connection: ['3'],
  },
  'endpoint:wineventlog': {
    process_creation: ['4688'],
    file_event: ['4663'],
    registry_event: ['4657'],
    system: ['7045', '7036'],
    security: ['4698', '4702', '4699'],
    authentication_events: ['4624', '4625', '4648', '4672', '4776'],
    Rdp_event: ['4624', '4778', '4779'],
  },
}
